import { PerspectiveCamera } from "three";
import { ParamConfig } from "../../engine/nodes/utils/params/ParamsConfig";
import { CameraNodeType } from "../../engine/poly/NodeContext";
import { ThreejsViewer } from "../../engine/viewers/Threejs";
import { CoreCameraPerspectiveFrameMode } from "./frameMode/CoreCameraPerspectiveFrameMode";
export const PERSPECTIVE_CAMERA_DEFAULT = {
  fov: 50,
  fovRange: [1e-3, 180]
};
export function PerspectiveCameraParamConfigMixin(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.fov = ParamConfig.FLOAT(PERSPECTIVE_CAMERA_DEFAULT.fov, { range: PERSPECTIVE_CAMERA_DEFAULT.fovRange });
    }
  };
}
export const registerPerspectiveCamera = (poly) => {
  poly.registerCameraNodeType(CameraNodeType.PERSPECTIVE);
  poly.registerCamera(PerspectiveCamera, (options) => {
    const { camera, scene, canvas } = options;
    const viewer = new ThreejsViewer({
      camera,
      scene,
      updateCameraAspect: (aspect) => {
        CoreCameraPerspectiveFrameMode.updateCameraAspect(camera, aspect);
      },
      canvas
    });
    return viewer;
  });
};
